import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";

var _createReducer;

import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import get from 'lodash/get';
import { createAction, createReducer } from 'redux-act';
import { createSelector } from 'reselect';
import { selectCurrent } from '@gandi/redux-sharing';
import { selectFromConfig } from '@gandi/redux-config';

/**
 * Selectors
 */
export var selectAuthenticationState = function selectAuthenticationState(state) {
  return state.authentication;
};
/**
 * Return true if a user is found in the state.
 */

export var selectIsAuthenticatedUser = function selectIsAuthenticatedUser(state) {
  return !!state.authentication.userInfos && _Object$keys(state.authentication.userInfos).length > 0;
};
/**
 * Return Authenticated User Infos.
 */

export var selectAuthenticatedUserInfos = function selectAuthenticatedUserInfos(state) {
  return state.authentication.userInfos;
};
/**
 * Return true if the current user has cc2 or god roles.
 */

export var selectIsPrivilegedUser = createSelector(selectAuthenticatedUserInfos, function (infos) {
  var roles = get(infos, 'roles', []);
  return roles.indexOf('cc2') > -1 || roles.indexOf('god') > -1;
});
/**
 * Return true if the current user doesn't have the 'user_v5' role.
 * This means the user was migrated from a v4 handle, not created on v5 directly.
 */

export var selectIsMigratedUser = createSelector(selectAuthenticatedUserInfos, function (infos) {
  var roles = get(infos, 'roles', []);
  return roles.indexOf('user_v5') === -1;
});
/**
 * Return true if the current user is logged as a SAML user.
 */

export var selectIsSamlUser = createSelector(selectAuthenticatedUserInfos, function (user) {
  return !!user && (user.username.includes('@') || user.roles.includes('saml'));
});
/**
 * Return the country code
 * If the found country code is invalid, return the fallback.
 */

var invalidCountryCodes = ['Unknown', 'ZZ'];
export var selectUserCountryCode = createSelector(selectAuthenticationState, selectFromConfig('defaultCountryCode', 'US'), function (state, defaultCountryCode) {
  var countryCode = get(state, 'countryCode', defaultCountryCode);
  return invalidCountryCodes.indexOf(countryCode) === -1 ? countryCode : defaultCountryCode;
}); // Return current currency or return the default one set in the configuration

export var selectCurrentCurrency = createSelector(selectAuthenticationState, selectFromConfig('defaultCurrency', 'USD'), function (state, defaultCurrency) {
  return get(state, 'currencies.current', defaultCurrency);
}); // Return the currency of user's prepaid, if any

export var selectUserCurrency = createSelector(selectAuthenticationState, function (state) {
  return get(state, 'currencies.current');
}); // return whether user wants to display taxes including prices or not

export var selectTaxesDisplaySetting = createSelector(selectAuthenticationState, selectCurrent, function (state, sharing) {
  return sharing ? sharing.type === 'individual' : get(state, 'taxesIncluded', true);
});
/**
 * Action
 */

export var saveAuthenticatedUserInfos = createAction('Save authenticated user info');
export var saveUserCountryCode = createAction('Save user country code');
export var loadCurrenciesStart = createAction('Start Loading Currencies');
export var saveCurrencies = createAction('Save currencies');
export var saveCurrentCurrency = createAction('Save current currency');
export var loadCurrenciesFail = createAction('Load currencies fail');
export var saveTaxesDisplaySetting = createAction('Save user taxes display preference');
/**
 * Reducer
 */

export var initialState = {
  userInfos: undefined,
  currencies: {
    loading: false,
    current: '',
    list: []
  },
  countryCode: undefined
};
export default createReducer((_createReducer = {}, _defineProperty(_createReducer, saveAuthenticatedUserInfos, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    userInfos: _objectSpread(_objectSpread({}, state.userInfos), payload)
  });
}), _defineProperty(_createReducer, loadCurrenciesStart, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currencies: {
      loading: true
    }
  });
}), _defineProperty(_createReducer, saveCurrencies, function (state, data) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currencies: _objectSpread(_objectSpread({}, state.currencies), {}, {
      loading: false,
      list: data
    })
  });
}), _defineProperty(_createReducer, saveCurrentCurrency, function (state, data) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currencies: _objectSpread(_objectSpread({}, state.currencies), {}, {
      loading: false,
      current: data
    })
  });
}), _defineProperty(_createReducer, loadCurrenciesFail, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    currencies: _objectSpread(_objectSpread({}, state.currencies), {}, {
      loading: false
    })
  });
}), _defineProperty(_createReducer, saveUserCountryCode, function (state, data) {
  return _objectSpread(_objectSpread({}, state), {}, {
    countryCode: data
  });
}), _defineProperty(_createReducer, saveTaxesDisplaySetting, function (state, data) {
  return _objectSpread(_objectSpread({}, state), {}, {
    taxesIncluded: data
  });
}), _createReducer), initialState);